/* This file is automatically generated, do not edit manually! */

/* eslint-disable */

exports.FEATURE_INDEX = {
  '@AM': ['Amstrad Gamma'],
  '@BE': ['Benefon Q'],
  '@CK': ['CK13[ai]?$!', 'CK15[ai]?$!'],
  '@CO': ['COCOON'],
  '@EF': ['EF71'],
  '@EX': ['EX115', 'EX118', 'EX119', 'EX128', 'EX225', 'EX226', 'EX430'],
  '@F1': ['F100[ai]?$!'],
  '@GM': ['GM360'],
  '@GR': ['GR700'],
  '@GS': ['GS290', 'GS500'],
  '@GT': [
    'GT500!',
    'GT550',
    'GT-B2710',
    'GT-B3210',
    'GT-B3313',
    'GT-C3200',
    'GT-C3222',
    'GT-C3322',
    'GT-C3500',
    'GT-C5010!',
    'GT-E1282!',
    'GT-E2152',
    'GT-E2220',
    'GT-E2222',
    'GT-E2202',
    'GT-E2250',
    'GT-E2252',
    'GT-E3213',
    'GT-E3309I',
    'GT-M8910',
    'GT-S3332',
    'GT-S33(50|53)!',
    'GT-S35(70|72)!',
    'GT-S5229',
    'GT-S5270!',
    'GT-S5610!',
    'GT-I6410!',
    'GT-I8320!',
    'GT-I8330!'
  ],
  '@J1': ['J105[ai]?$!', 'J108[ai]?$!', 'J10(i2?)?$!'],
  '@J2': ['J20[ai]?$!'],
  '@K6': ['K612'],
  '@KC': ['KC910i'],
  '@KP': ['KP500!', 'KP570!'],
  '@KU': ['KU990i'],
  '@LG': ['LG-KU380', 'LG-KU580', 'LG-KU990'],
  '@LI': ['Lightpipe'],
  '@M3': ['m3510c'],
  '@MO': ['MOTOQA1'],
  '@P7': ['P7000'],
  '@P9': ['P9020', 'P9050'],
  '@PL': ['PLS6600KJ'],
  '@PM': ['PM-8200'],
  '@S7': ['S7350'],
  '@SA': ['sam-r560'],
  '@SC': ['SCP-5300', 'SCP-5500', 'SCP-6600', 'SCH-W169', 'SCH-W279'],
  '@SE': ['Sendo Wap'],
  '@SG': [
    'SGH-A667',
    'SGH-A697',
    'SGH-A877',
    'SGH-A927',
    'SGH-A997',
    'SGH-D880',
    'SGH-E250i',
    'SGH-E250V',
    'SGH-G600',
    'SGH-J700i',
    'SGH-J700V',
    'SGH-M200',
    'SGH-S150G',
    'SGH-S390G',
    'SGH-T189N',
    'SGHX660V',
    'SGH-Z107!',
    'SGH-Z130!',
    'SGH-Z500!'
  ],
  '@SM': ['SM-B313E', 'SM-B350E', 'SM-B360E', 'SM-B780(A|W)!'],
  '@TE': ['tecnot36'],
  '@U1': ['U100[ai]?$!', 'U10[ai]?$!'],
  '@VO': ['Vodafone 575'],
  '@W1': ['W100i?$!', 'W150i?$!'],
  '@W2': ['W20i?$!'],
  '@WI': ['WIDETEL WCX150'],
  '@WT': ['WT13i$!'],
  '@X5': ['X5i$!']
};

/* This file is automatically generated, do not edit manually! */
